import type { FaireProductEntity } from "../../entity_types/product";

export const p_72ferz4xxh: FaireProductEntity = {
  token: "p_72ferz4xxh",
  type: "product",
  name: "Boho Print Maxi Skirt",
  brandToken: "b_ysnwrcjujg",
  brandName: "Mccolin",
  imageUrl:
    "https://cdn.faire.com/fastly/78b77a51168612c615361d6319a74496500084215956e23f17479a0ff0987a36.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/51512f48d6994b12d1d159780ff121fe2f1b19eaca874b9e11358000a7fbdc01.jpeg",
    "https://cdn.faire.com/fastly/11b7f821e941c3005178678184e8d933e6ff7207a45ca0eceeaea4e7d18d2095.jpeg",
    "https://cdn.faire.com/fastly/1df4e80fb2cd497aad25adaf12a8e04dd3e1df33a6236b18b3b6696cdd02b4ce.jpeg",
    "https://cdn.faire.com/fastly/e353c75e9733ada5e3f30070ad811e9a953037abb03139114200190366652fa7.jpeg",
  ],
  priceDollars: 27.27,
  description:
    "Your new favorite skirt showcases an elegant boho print design. Effortlessly elevates your style for both casual and formal occasions.\n\nFabric: 100% polyester\n\nWeight: 1.1 lb\n",
  tags: [],
  msrpDollars: 54.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:45.560Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
